export class MaintenanceRun {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "workspaceId",
            "baseName": "workspaceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "runType",
            "baseName": "runType",
            "type": "MaintenanceRunType",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MaintenanceRunStatus",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "failureMessage",
            "baseName": "failureMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MaintenanceRun.attributeTypeMap;
    }
    constructor() {
    }
}
